import React from 'react';
import Select, { ISelectOption, ISelectCustomProps } from '@creditflowresearch/uilib/Select';
import { Props, GroupBase } from 'react-select';
import cn from 'classnames';
import styles from './ttmSelect.module.scss';

const TTMSelect = <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
>(props: ISelectCustomProps<SOption, IsMulti, Group> & Props<SOption, IsMulti, Group>): React.ReactElement => (
  <Select<SOption, IsMulti, Group>
    { ...props }
    isSlim
    isNarrow
    isSearchable={ false }
    size="S"
    className={ cn(styles.select, props.className) }
  />
);

export default TTMSelect;
